module.exports = __webpack_public_path__ + "static/img/lb3.1de0768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb3.png
// module id = XQph
// module chunks = 0